import React from 'react';

/**
 * Loading Spinner Component
 * Used as fallback for React.lazy() Suspense boundaries
 */
const LoadingSpinner = ({ message = '', className = 'h-64' }) => {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className="animate-spin rounded-full h-12 w-12 border-4"
        style={{ borderColor: 'var(--color-accent)', borderTopColor: 'transparent' }}
      ></div>
      {message && (
        <p className="mt-4 text-gray-600 dark:text-gray-400 font-medium text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
